module.exports = __webpack_public_path__ + "img/12.cb0315d1.png";